import React, { useState } from 'react';
import AppSpinner from "../Spinner/AppSpinner";
import { Modal } from 'react-bootstrap';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";

const AddSectionModal = ({ show, onHide, trainingId, trainingName, onSuccess }) => {
  const [form, setForm] = useState({ 
    nameAz: '', 
    nameRu: '', 
    nameEn: '', 
    description: '' 
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async () => {
    // Əsas dil (Az) mütləq olmalıdır
    if (!form.nameAz.trim()) {
      setError('Bölmə adı (AZ) mütləqdir.');
      return;
    }

    setLoading(true);

    // Team leaderin istədiyi format: Az::: (input) Rus::: (input) Eng::: (input)
    const combinedName = `Az::: ${form.nameAz.trim()} Rus::: ${form.nameRu.trim()} Eng::: ${form.nameEn.trim()}`;

    try {
      const response = await apiFetch(`${BASE_URL}/sections`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: combinedName, 
          description: form.description,
          trainingId: trainingId
        })
      });

      if (!response.ok) throw new Error('Xəta baş verdi');
      
      setForm({ nameAz: '', nameRu: '', nameEn: '', description: '' });
      onSuccess && onSuccess();
      onHide();
    } catch (err) {
      setError('Bölmə əlavə edilərkən xəta baş verdi.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setForm({ nameAz: '', nameRu: '', nameEn: '', description: '' });
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header style={{
        background: '#f3f4f6',
        borderBottom: '1px solid #e5e7eb',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 700, color: '#374151', fontSize: 14 }}>
            {trainingName}
          </span>
          <span style={{ color: '#d1d5db' }}>|</span>
          <span style={{ color: '#6b7280', fontSize: 12 }}>Yeni Bölmə</span>
        </div>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
          aria-label="Close"
          style={{ margin: 0 }}
        />
      </Modal.Header>

      <Modal.Body style={{ padding: '20px 20px 8px', background: '#fff' }}>
        
        {/* AZERBAIJANI NAME */}
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>
            Bölmə Adı (AZ) <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <input
            name="nameAz"
            value={form.nameAz}
            onChange={handleChange}
        
            style={{
              ...inputStyle,
              borderColor: error && !form.nameAz.trim() ? '#ef4444' : '#e5e7eb'
            }}
          />
        </div>

        {/* RUSSIAN NAME */}
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Bölmə Adı (RU)</label>
          <input
            name="nameRu"
            value={form.nameRu}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        {/* ENGLISH NAME */}
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Bölmə Adı (EN)</label>
          <input
            name="nameEn"
            value={form.nameEn}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Təsvir</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder="Bölmə haqqında qısa məlumat"
            rows={3}
            style={{
              ...inputStyle,
              resize: 'vertical',
              minHeight: 72
            }}
          />
        </div>

        {error && (
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 6,
            padding: '6px 12px',
            color: '#dc2626',
            fontSize: 12,
            marginBottom: 8
          }}>
            {error}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{
        background: '#f9fafb',
        borderTop: '1px solid #e5e7eb',
        padding: '10px 16px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8
      }}>
        <button
          onClick={handleClose}
          disabled={loading}
          style={{
            background: '#fff',
            color: '#374151',
            border: '1px solid #d1d5db',
            borderRadius: 6,
            padding: '6px 16px',
            fontWeight: 600,
            fontSize: 12,
            cursor: 'pointer'
          }}
        >
          Ləğv et
        </button>
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            background: loading ? '#86efac' : '#22c55e',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '6px 18px',
            fontWeight: 600,
            fontSize: 12,
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background 0.15s'
          }}
        >
          {loading ? (
            <>
              <AppSpinner inline />
              Əlavə edilir...
            </>
          ) : (
            <>
              <svg viewBox="0 0 22 22" fill="white" xmlns="http://www.w3.org/2000/svg" style={{ width: 14, height: 14 }}>
                <path d="M11.75 8C11.75 7.586 11.414 7.25 11 7.25S10.25 7.586 10.25 8v2.25H8c-.414 0-.75.336-.75.75s.336.75.75.75h2.25V14c0 .414.336.75.75.75s.75-.336.75-.75v-2.25H14c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2.25V8Z" fill="white"/>
              </svg>
              Əlavə et
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

// Styles
const labelStyle = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#374151',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  marginBottom: 5
};

const inputStyle = {
  width: '100%',
  border: '1px solid #e5e7eb',
  borderRadius: 6,
  padding: '7px 10px',
  fontSize: 12,
  color: '#111827',
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit'
};

export default AddSectionModal;